import { Injectable } from '@angular/core';
import { environment } from 'app/../environments/environment';
import { AppComponent } from './app.component';

@Injectable({
	providedIn: 'root'
})
export class EnvService {
	baseHRef: string;
	app!: AppComponent;
	constructor() {
		this.baseHRef = environment.baseHref;
	}

	SetApp(app:AppComponent) {
		this.app = app;
	}

	GetEnvParam(param: string): any {
		if (environment.hasOwnProperty(param)) {
			return (environment as any)[param];
		}
		return null;
	}

	GetRelPath(path: string, relTo?: string): string {
		relTo = (relTo === undefined) ? this.GetURL() : relTo;
		if (path.substring(0, 1) === '/') {
			path = path.substring(1);

			if (path.indexOf('public') < 0) {
				path = this.IsPublic() ? '/public' + ((path === '') ? '' : '/') + path : '/' + path;
			}
		}
		const loc: Array<string> = !!relTo ? relTo.split('/') : [];

		/* if (path.indexOf('http') === 0) {
			if (path.indexOf(environment.baseHref.split('/').slice(2).join('/')) > -1) {
				path = path.replace(environment.baseHref.split('/').slice(2).join('/'), '');
			}
		}
		*/
		if (path.indexOf('localhost') > -1) {
			path = path.substring(path.indexOf('localhost'));
			path = '/' + path.split('/').slice(1).join('/');
		}
		if (path.indexOf(this.baseHRef) > -1) {
			path = path.substring(path.indexOf(this.baseHRef) + this.baseHRef.length);
		}

		return path;
	}
	GetPrevPath(prevCount: number = 1, path?: string): string {
		if (path === undefined) {
			path = document.location.href;
		}
		const pathParts: Array<string> = path.split('/');
		for (let ctr = 0; ctr < prevCount; ctr++) {
			pathParts.pop();
		}
		return this.GetRelPath(pathParts.join('/'));

	}

	GetURL() {
		return environment.baseHref;
		// return document.location.href;
	}
	IsPublic() {
		return this.GetRelPath(document.location.href).split('/').indexOf('public') === 0;
	}
	GetAppNameFromURL(): string {
		const path = this.GetRelPath(document.location.href).split('/');
		if (this.IsPublic()) {
			if (path.length > 1) {
				return 'public' + '/' + path[1];
			}
			return '';
		} else {
			if (path.length > 0) {
				return path[0];
			}
			return '';
		}
	}
	GetAppURL(): string {
		return environment.completeURL + this.GetAppNameFromURL() + '/';
	}
	AwesomeCheck() {
		const doc: any = window.document;
		const fonts = 'fonts';
		if (doc[fonts] && !!doc[fonts].forEach) {
			let done = false;
			let match = false;
			if (!!doc[fonts].forEach) {
				doc[fonts].forEach((fontFace:any) => {
					if (done === true) {
						return;
					}
					let family = fontFace.family;
					family = family.replace('\'', '');
					family = family.replace('\'', '');
					family = family.replace('"', '');
					family = family.replace('"', '');


					if (['Font Awesome 5 Free'].indexOf(family)) {
						done = true;
						match = true;
						return;
					}
				});
			}
			if (match === false) {
				window.requestAnimationFrame(this.AwesomeCheck.bind(this));

			} else {
				this.ShowAwesomeness();
			}
		} else {
			this.ShowAwesomeness();
		}

	}
	ShowAwesomeness() {
		setTimeout(() => {
			document.body.classList.toggle('awesomeless', false);
		}, 2500);
	}
	GetPosition(element:HTMLElement):{left:number,top:number} {
		const clientRect:any = element.getBoundingClientRect();
		return {left: clientRect.left + document.body.scrollLeft,
				top: clientRect.top + document.body.scrollTop};
	}

}
